

























































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import LoadingMixin from "@/mixins/LoadingMixin";
import ContentMixin from "@/mixins/ContentMixin";
import AudioPlayer from "@/components/ccat/AudioPlayer.vue";
import DynamicAudioPlayer from "@/components/ccat/DynamicAudioPlayer.vue";
import { IQuestion } from "@/store/modules/content/types";
import { IUSection } from "@/store/types";
import ImgContainer from "@/components/common/ImgContainer.vue";
import draggable from "vuedraggable";

@Component({
  name: "question-body",
  components: {
    AudioPlayer,
    DynamicAudioPlayer,
    ImgContainer,
    draggable,
  },
})
export default class QuestionBody extends mixins(ContentMixin) {
  @Prop({ default: 1 })
  public questionNum!: number;

  @Prop({ default: "" })
  public subject!: string;

  @Prop({ default: "" })
  public grade!: number;

  @Prop({ default: {} })
  public question!: IQuestion;

  @Prop({ default: {} })
  public section!: IUSection;

  @Prop({ default: null })
  public passage!: any;

  @Prop({ default: "" })
  public optionOver!: string;

  @Prop({ default: "" })
  public optionSelected!: string;

  @Prop({ default: null })
  public answer_obj!: Map<number, number> | null;

  @Prop({ default: false })
  public isLoading!: boolean;

  public preventOptionClick = false;
  public promptQMModalOpened = false;
  private isProcessingOption = false;

  public checkInCorrect(k: string) {
    return (
      this.section &&
      this.section.is_completed &&
      this.section.correct &&
      this.section.correct[this.questionNum] === k &&
      !this.checkCorrect(k)
    );
  }

  public checkCorrect(k: string) {
    return (
      this.section &&
      this.section.is_completed &&
      this.optionSelected === k &&
      this.section.correct &&
      this.section.correct[this.questionNum] === k
    );
  }

  get questionKey() {
    return Date.now() + this.questionNum;
  }

  get hasAudio() {
    /*
    if (this.subject === "reading") {
      return this.grade.toLowerCase() === "k";
    } else {
      return true;
    }
    */

    return true;
  }

  get questionType() {
    return this.question.type;
  }

  get options() {
    const options: any = this.question.choice_obj || this.question.options;

    if (options) {
      const orderedOptions: any = {};
      Object.keys(options)
        .sort()
        .forEach(function(key) {
          orderedOptions[key] = options[key];
        });

      return orderedOptions;
    } else {
      return {};
    }
  }

  public isEmpty(data: any) {
    let ret = false;
    if (typeof data === "object") {
      ret = JSON.stringify(data) === JSON.stringify({});

      if (!ret && data) {
        for (const key of Object.keys(data)) {
          const content = data[key];

          let ret_content = true;

          if (content === null) {
            ret_content = true;
          } else {
            for (const content_key of Object.keys(content)) {
              const content_val = content[content_key];

              if (content_val !== "") {
                ret_content = false;
              }
            }
          }

          return ret_content;
        }
      }
    } else if (typeof data === "string") {
      ret = data.length === 0;
    } else {
      return false;
    }

    return ret;
  }

  get hasContentsLeft() {
    return (
      !this.isEmpty(this.question.content_audio) ||
      !this.isEmpty(this.question.content_image) ||
      !this.isEmpty(this.question.content_video) ||
      (this.isEmpty(this.question.content_video) && this.question.type === "B")
    );
  }

  get optionsToRight() {
    return (
      this.subject.toLowerCase() === "reading" && !this.isEmpty(this.passage)
    );
  }

  public onMouseEnterOption(option: string) {
    this.$emit("option:over", option);
  }

  public onMouseLeaveOption(option: string) {
    this.$emit("option:over", "");
  }

  public onOptionClick(option: string) {
    if (this.isProcessingOption) {
      return;
    }

    this.isProcessingOption = true;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(async function() {
      if (!self.section.is_completed) {
        if (!self.preventOptionClick) {
          self.$emit("option:selected", option);
        }
        self.preventOptionClick = false;
      }
    }, 100);

    this.isProcessingOption = false;
  }

  public onOptionAudioClick(option: string) {
    this.preventOptionClick = true;
  }

  public onZoomOver(val: boolean) {
    this.preventOptionClick = val;
  }

  //TYPE O

  public originalAnswersPositions: any = null;
  public newAnswersPositions: any = null;
  public finalAnswersPositions: any = {};
  public draggingAnswer = null;
  public dragging = false;
  public enabled = true;

  beforeMount() {
    if (this.question.type === "O") {
      this.originalAnswersPositions = this.answersIndex();
    }
  }

  get draggingList() {
    return this.answersIndex();
  }

  public answersIndex() {
    let list: any = [];

    if (this.answer_obj && typeof this.answer_obj !== "string") {
      list = Object.values(this.answer_obj);
    } else {
      list = Object.keys(this.question.content_da).map(
        (q: any, idx: number) => idx + 1
      );
    }

    return list;
  }

  public checkMove(e: any) {
    this.draggingAnswer = e.draggedContext.element;
    this.newAnswersPositions = this.draggingList;
  }

  public finishMove(): void {
    this.dragging = false;
    const result = this.newAnswersPositions;

    if (result) {
      this.finalAnswersPositions = result;

      this.$emit("order:answer_obj", result);
      this.$emit("order:sortingAnswers", true);
      this.$set(this.question, "student_answer", null);
      this.$set(this.question, "correct", null);
      this.$set(this.question, "correct_obj", null);
    }
  }

  public moveOption(index: number, direction: string) {
    const list = this.draggingList;
    const num = list[index];

    const index_next = index + 1;
    const next = list[index_next];

    const index_prev = index - 1;
    const prev = list[index_prev];

    if (direction === "down") {
      list[index] = next;
      list[index_next] = num;
    } else {
      list[index] = prev;
      list[index_prev] = num;
    }

    this.newAnswersPositions = list;
    this.finishMove();
  }

  get finishedList() {
    return this.finalAnswersPositions;
  }

  get contentList() {
    const fap: any = this.finalAnswersPositions;
    const da: any = this.question.content_da;
    const order: any = {};

    if (Object.keys(fap).length) {
      let i = 0;
      Object.keys(fap).forEach(function(item) {
        const o: any = fap[item] - 1;
        order[o] = da[i];
        i++;
      });
      return order;
    } else {
      return this.question.content_da;
    }
  }
}
